import { byId, isAr, message, copyText, trackEvent } from './extra-common.js';

document.querySelectorAll('[data-hash]').forEach((button) => button.addEventListener('click', async () => {
  if (!crypto.subtle) { message('hg-status', isAr ? 'المتصفح لا يدعم Web Crypto في هذا الاتصال.' : 'Web Crypto is unavailable in this context.', 'error'); return; }
  trackEvent('tool_started', 'hash-generator');
  button.disabled = true;
  try {
    const bytes = new TextEncoder().encode(byId('hg-input').value);
    const digest = new Uint8Array(await crypto.subtle.digest(button.dataset.hash, bytes));
    byId('hg-output').value = Array.from(digest, (byte) => byte.toString(16).padStart(2, '0')).join('');
    byId('hg-copy').disabled = false;
    message('hg-status', `${button.dataset.hash} · ${digest.length * 8} ${isAr ? 'بت' : 'bits'}`, 'success');
    trackEvent('tool_completed', 'hash-generator');
  } catch {
    message('hg-status', isAr ? 'تعذر حساب البصمة.' : 'Unable to calculate the digest.', 'error');
    trackEvent('tool_failed', 'hash-generator');
  }
  finally { button.disabled = false; }
}));
byId('hg-uuid').addEventListener('click', () => {
  trackEvent('tool_started', 'hash-generator');
  if (crypto.randomUUID) byId('hg-output').value = crypto.randomUUID();
  else {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    byId('hg-output').value = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
  }
  byId('hg-copy').disabled = false;
  message('hg-status', isAr ? 'تم إنشاء UUID عشوائي آمن.' : 'Cryptographically random UUID generated.', 'success');
  trackEvent('tool_completed', 'hash-generator');
});

const inputEl = byId('hg-input');
inputEl.addEventListener('dragover', (e) => e.preventDefault());
inputEl.addEventListener('drop', async (e) => {
  e.preventDefault();
  const file = e.dataTransfer.files[0];
  if (!file) return;
  message('hg-status', isAr ? `جارٍ حساب بصمة الملف: ${file.name}…` : `Hashing file: ${file.name}…`);
  try {
    const buffer = await file.arrayBuffer();
    const digest = new Uint8Array(await crypto.subtle.digest('SHA-256', buffer));
    const hex = Array.from(digest, (b) => b.toString(16).padStart(2, '0')).join('');
    inputEl.value = `[File] ${file.name} (${(file.size / 1024).toFixed(1)} KB)`;
    byId('hg-output').value = hex;
    byId('hg-copy').disabled = false;
    message('hg-status', `SHA-256 · ${file.name}`, 'success');
  } catch {
    message('hg-status', isAr ? 'تعذر حساب بصمة الملف.' : 'Could not hash file.', 'error');
  }
});
byId('hg-copy').addEventListener('click', async () => { try { await copyText(byId('hg-output').value); message('hg-status', isAr ? 'تم النسخ.' : 'Copied.', 'success'); } catch { message('hg-status', isAr ? 'تعذر النسخ.' : 'Copy failed.', 'error'); } });

